'use client'

import * as Sentry from '@sentry/nextjs'
import clsx from 'clsx'
import type { Metadata } from 'next'
import NextError from 'next/error'
import { Inter } from 'next/font/google'
import { useEffect } from 'react'

const inter = Inter({ subsets: ['latin'] })

export const metadata: Metadata = {
  title: 'Criteria Playground — Free Online API Editor',
  description: 'Free online tool to create and share OpenAPI documents.'
}

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="en">
      <body className={clsx(inter.className, 'overflow-hidden')}>
        {/* This is the default Next.js error component but it doesn't allow omitting the statusCode property yet. */}
        <NextError statusCode={undefined as any} />
      </body>
    </html>
  )
}
